module.exports = __webpack_public_path__ + "img/pc_email.bdb1497e.svg";